import { constants } from "../../../constants";

export default class FreeRoundsFinished {
    constructor(gb) {
        Object.assign(this, { gb });
    }
    GREENTUBE_handler(msg) {
        this.gb.emitters.emit.game.customMsg(msg);
        this.gb.queryParams.freeRounds = false;
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.GREENTUBE:
                event["freeSpinsFinished"] = this.GREENTUBE_handler;
                break;
        }

        return event;
    }
}